import { useEffect } from 'react';

/**
 * E1 (QUALITY-NCR-REVIEW E2E run): open the NCR page at the top. Arriving from
 * the create form kept its scroll position, so the NCR opened mid-form.
 *
 * @param ncrId - the loaded NCR's id; undefined while it loads
 * @returns nothing
 */
export function useScrollTopOnLoad(ncrId: number | undefined): void {
  useEffect(() => {
    if (ncrId != null) window.scrollTo(0, 0);
  }, [ncrId]);
}
